import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';

import {
  HeadingDisplay,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  Row
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

import { IPortfolioSheetData } from '@/modules/catalog/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Investment',
  setup(__props) {

const changeAmountValue = inject(
  'changeAmountValue',
  (value: number, formatted: string) => ({ value, formatted })
);

const portfolioSheetData = inject(
  'portfolioSheetData'
) as Ref<IPortfolioSheetData>;
const isCreatingPortfolio = inject('isCreatingPortfolio') as Ref<boolean>;

const router = useRouter();
const route = useRoute();
const amountFormatted = ref('');
const amountValue = ref(0);

const isDisabled = computed(() => {
  return (
    amountValue.value <= 0 ||
    status.value === 'error' ||
    isCreatingPortfolio.value
  );
});

const minimumInvestment = computed(() => {
  return portfolioSheetData.value.investment.minimumInvestment.value;
});

const availableBalance = computed(() => {
  return portfolioSheetData.value.investment.availableBalance.value;
});

const hasBalance = computed(() => {
  return portfolioSheetData.value.investment.availableBalance.value > 0;
});

const totalAfterInvestment = computed(() => {
  return moneyFormat(amountValue.value);
});

const headerValueClass = computed(() => {
  return hasBalance.value ? '' : 'investment__header--value';
});

const balanceValue = computed(() => {
  return hasBalance.value
    ? portfolioSheetData.value.investment.availableBalance.formatted
    : 'Depositar';
});

const hasInsufficientBalance = computed(() => {
  return !hasBalance.value || amountValue.value > availableBalance.value;
});

const shouldRedirectToInvestmentFlow = computed(() => {
  return hasInsufficientBalance.value;
});

function redirectToDeposit() {
  if (hasBalance.value) return;

  const routeParams = shouldRedirectToInvestmentFlow.value
    ? { params: { cameFrom: route.fullPath } }
    : {};
  router.push({ name: 'deposit-pix', ...routeParams });
}

const status = computed(() => {
  return (amountValue.value < minimumInvestment.value &&
    amountValue.value !== 0) ||
    amountValue.value > availableBalance.value
    ? 'error'
    : '';
});

const helperText = computed(() => {
  if (amountValue.value < minimumInvestment.value && amountValue.value !== 0)
    return `O valor mínimo de investimento nesta carteira é ${portfolioSheetData.value.investment.minimumInvestment.formatted}`;
  if (amountValue.value > availableBalance.value)
    return `Valor maior que o saldo disponível: ${portfolioSheetData.value.investment.availableBalance.formatted}`;

  return '';
});

function investClick() {
  changeAmountValue(amountValue.value, amountFormatted.value);
}

function onChangeValue(data: { value: number; formatted: string }) {
  amountFormatted.value = data.formatted;
  amountValue.value = data.value;
}

return { __sfc: true,changeAmountValue, portfolioSheetData, isCreatingPortfolio, router, route, amountFormatted, amountValue, isDisabled, minimumInvestment, availableBalance, hasBalance, totalAfterInvestment, headerValueClass, balanceValue, hasInsufficientBalance, shouldRedirectToInvestmentFlow, redirectToDeposit, status, helperText, investClick, onChangeValue, HeadingDisplay, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, Row, NebraskaColors, SingleInputMoney, moneyFormat }
}

})